import { formatToBRL } from "@/utils/formatToMoney";

type SumTone = "neutral" | "ok" | "diverge";

function resolveTone(hasAnySelection: boolean, isBalanced: boolean): SumTone {
  if (!hasAnySelection) return "neutral";
  if (isBalanced) return "ok";
  return "diverge";
}

function cardClassForTone(tone: SumTone, active: boolean): string {
  const base = "flex-1 border rounded-md p-3 transition-colors";
  const neutral = "bg-white border-slate-200";
  if (!active || tone === "neutral") return `${base} ${neutral}`;
  if (tone === "ok") return `${base} bg-emerald-50 border-emerald-300`;
  if (tone === "diverge") return `${base} bg-rose-50 border-rose-300`;
  return `${base} ${neutral}`;
}

function diffClassForTone(tone: SumTone): string {
  if (tone === "ok") return "text-emerald-700";
  if (tone === "diverge") return "text-rose-700";
  return "text-slate-500";
}

interface SumHeaderProps {
  sumNsu: number;
  sumDeposit: number;
  diff: number;
  isBalanced: boolean;
  hasAnySelection: boolean;
  nsuCount: number;
  depositCount: number;
}

export default function SumHeader({
  sumNsu,
  sumDeposit,
  diff,
  isBalanced,
  hasAnySelection,
  nsuCount,
  depositCount,
}: SumHeaderProps) {
  const tone = resolveTone(hasAnySelection, isBalanced);
  const cardClass = (active: boolean) => cardClassForTone(tone, active);
  const diffClass = diffClassForTone(tone);

  return (
    <div
      className="flex flex-col lg:flex-row gap-3 mb-3"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className={cardClass(nsuCount > 0)}>
        <div className="text-xs text-slate-500">
          Σ NSU selecionadas
          <span className="ml-1 text-slate-400">({nsuCount})</span>
        </div>
        <div className="text-lg font-bold text-slate-900">
          {formatToBRL(sumNsu)}
        </div>
      </div>

      <div className={cardClass(depositCount > 0)}>
        <div className="text-xs text-slate-500">
          Σ Depósitos selecionados
          <span className="ml-1 text-slate-400">({depositCount})</span>
        </div>
        <div className="text-lg font-bold text-slate-900">
          {formatToBRL(sumDeposit)}
        </div>
      </div>

      <div className={cardClass(true)}>
        <div className="text-xs text-slate-500">Diferença</div>
        <div className={`text-lg font-bold ${diffClass}`}>
          {hasAnySelection ? formatToBRL(diff) : "—"}
        </div>
      </div>
    </div>
  );
}
